export default class EquipeFuncaoEnum {
    static Gestor = { id: 1, nome: 'Gestor', descricao: 'Gestor da Equipe' }
    static Agente = { id: 2, nome: 'Agente', descricao: 'Agente da Equipe' }
}
